import { Stack } from '@mui/material';
import { TestRun } from '../../types';
import Chip from '../Chip';

const resultsRenderer = (value: TestRun) => (
  <Stack direction="row" sx={{ gap: 1 }}>
    {value.test_runs?.totals.passed > 0 && (
      <Chip label={value.test_runs?.totals.passed} color="success" />
    )}
    {value.test_runs?.totals.warnings > 0 && (
      <Chip label={value.test_runs?.totals.warnings} color="warning" />
    )}
    {(value.test_runs?.totals.errors > 0 ||
      value.test_runs?.totals.failures > 0) && (
      <Chip
        label={
          (value.test_runs?.totals.errors || 0) +
          (value.test_runs?.totals.failures || 0)
        }
        color="error"
      />
    )}
  </Stack>
);

export default resultsRenderer;
